import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/">
              <img
                src="https://static.readdy.ai/image/af84490e484a32258481d5416d7d609f/d78e5faf28d5fcd317efb0ee3ee0e6ef.png"
                alt="Cycle Clarity Logo"
                className="h-12 w-auto cursor-pointer"
              />
            </Link>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-violet-600' : 'text-white hover:text-violet-200'
              }`}
            >
              Home
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-violet-600' : 'text-white hover:text-violet-200'
              }`}
            >
              About Us
            </Link>
            <a
              href="#testimonials"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-violet-600' : 'text-white hover:text-violet-200'
              }`}
            >
              Testimonials
            </a>
            <Link
              to="/contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-violet-600' : 'text-white hover:text-violet-200'
              }`}
            >
              Contact
            </Link>
            <a
              href="https://payhip.com/b/EvcbM"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-violet-600 text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-violet-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Get Started
            </a>
          </div>
          <button className="md:hidden text-gray-700 cursor-pointer">
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-700' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
